<template>
  <div style="width: 100%; height: 100%">
    <div class="storeMap"
         style="width: 100%; height: 100%"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

const colors = ['#91CC75']
export default {
  props: {
    chartData: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      chart: {}
    }
  },
  created () { },
  mounted () {
    this.chart = echarts.init(document.querySelector('.storeMap'))
    // 根据浏览器宽度变化改变可视化报表图宽高
    window.addEventListener('resize', () => {
      this.chart.resize()
    })
    this.updateCharts()
    console.log('this.convertData(this.dataArray): ', this.convertData(this.dataArray))
  },
  methods: {
    updateCharts () {
      this.chart.setOption && this.chart.setOption({
        title: {
          text: `原料库`,
          textStyle: {
            color: '#fff'
          },
          left: '12%',
          top: '3%'
        },
        color: colors,
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            const { name, value, percent } = params.data
            return name && percent ? `${name}: ${value}吨  ${percent}%` : `总库存${value}吨`
          }
        },
        series: [
          {
            type: 'treemap',
            leafDepth: 2,
            // leafDepth 表示『展示几层』，层次更深的节点则被隐藏起来。点击则可下钻看到层次更深的节点。
            // 例如，leafDepth 设置为 1，表示展示一层节点。
            breadcrumb: {
              show: false // 是否显示下面的面包屑导航
            },
            roam: false, // 是否开启拖拽漫游（移动和缩放）
            nodeClick: false, // 点击节点后的行为,false无反应
            data: [
              {
                name: '原料库',
                value: 100,
                children: [
                  {
                    name: '料堆1',
                    value: 10,
                    percent: 10
                  },
                  {
                    name: '料堆2',
                    value: 10,
                    percent: 10
                  },
                  {
                    name: '料堆3',
                    value: 6,
                    percent: 6
                  },
                  {
                    name: '料堆4',
                    value: 3,
                    percent: 3
                  },
                  {
                    name: '料堆5',
                    value: 11,
                    percent: 11
                  },
                  {
                    name: '料堆6',
                    value: 12,
                    percent: 12
                  },
                  {
                    name: '料堆7',
                    value: 1,
                    percent: 1
                  },
                  {
                    name: '料堆8',
                    value: 17,
                    percent: 17
                  },
                  {
                    name: '料堆9',
                    value: 30,
                    percent: 30
                  }
                ]
              }
            ],
            levels: [
              {
                itemStyle: {
                  borderColor: '#43b3ef',
                  borderWidth: 4,
                  gapWidth: 4
                }
              },
              {
                colorSaturation: [0.1, 0.6],
                itemStyle: {
                  borderColorSaturation: 0.7,
                  gapWidth: 2,
                  borderWidth: 2
                }
              }
            ],
            layoutSize: 'total' // 设置布局大小为容器总大小
          }
        ]
      })
    }
  }
  // watch: {
  //   chartData: {
  //     handler (val) {
  //       this.updateCharts()
  //     },
  //     deep: true
  //   }
  // }
}
</script>

<style scoped lang="scss"></style>
